import { StyleSheet } from 'react-native-unistyles';
import Button from '@/components/UI/Button';
import Text from '@/components/UI/Text';
import { navigateFromDrawer } from '@/stores/useRootStore';
import Box from '../../UI/Box';
import Icon from '../../Unistyles/Icon';

export default function DrawerEntityListTeamHeader() {
  return (
    <>
      <Box style={style.header}>
        <Box style={style.headerTitle}>
          <Icon variant="typographySecondary" size="xl" name="people-outline" />
          <Text
            variant="typographySecondary"
            bold
            flexShrink={1}
            numberOfLines={2}
            size="sm"
            style={style.headerTitleText}
          >
            Teams You're On
          </Text>
        </Box>
      </Box>
      <Box style={style.actions}>
        <Button
          accessibilityLabel="Join a team"
          appearance="outline"
          style={style.actionButton}
          size="xs"
          variant="secondary"
          testID="DrawerTeamJoinButton"
          onPress={() => {
            navigateFromDrawer({ pathname: '/team/join' });
          }}
        >
          <Icon accessible={false} name="enter-outline" size="sm" />
          <Button.Text flexShrink={1} numberOfLines={2} variant="typography">
            Join
          </Button.Text>
        </Button>
        <Button
          accessibilityLabel="Create a team"
          appearance="outline"
          style={style.actionButton}
          size="xs"
          variant="secondary"
          testID="DrawerTeamCreateButton"
          onPress={() => {
            navigateFromDrawer({ pathname: '/team/create' });
          }}
        >
          <Icon accessible={false} name="add-outline" size="sm" />
          <Button.Text flexShrink={1} numberOfLines={2} variant="typography">
            Create
          </Button.Text>
        </Button>
      </Box>
    </>
  );
}

const style = StyleSheet.create((theme) => ({
  header: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.space('sm'),
    padding: theme.space('md'),
  },
  headerTitle: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    gap: theme.space('sm'),
    alignItems: 'center',
  },
  headerTitleText: {
    minWidth: 0,
  },
  actions: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.space('sm'),
    paddingHorizontal: theme.space('md'),
    paddingTop: theme.space('xs'),
    paddingBottom: theme.space('sm'),
  },
  actionButton: {
    paddingHorizontal: theme.space('md'),
  },
}));
